import { Env } from '@/shared/config/environment';
import { HttpClient } from '@/shared/lib/http-client';

export const fetchPetsOffers = async ({ startFrom, insurancePeriod, earnings }) => {
  const response = await HttpClient.post(`${Env.server.mode}/insurance/pets/calculator`, {
    startFrom,
    insurancePeriod,
    earnings: Number(earnings),
  });

  return response.data?.data;
};